import Grid from '@mui/material/Grid';
import { FC, memo } from 'react';
import { useFormContext } from 'react-hook-form';

import useRole from '~/store/user/hooks/useRole';
import DatePicker from '~/ui/components/inputs/DatePicker';
import InputMask from '~/ui/components/inputs/InputMask';
import Select from '~/ui/components/inputs/SelectWithoutAnimation';
import TimePicker from '~/ui/components/inputs/TimePicker';

import { TypeOfVisit } from '~/ui/pages/Visits/constants/filterOptions';
import formatEnumToOptions from '~/ui/pages/Visits/utils/formatEnumToOptions';

import { ReactComponent as ClockIcon } from '~/ui/assets/images/clockIcon.svg';

interface IProps {
  clientNoShow: boolean;
}

const VisitDateSelectFields: FC<IProps> = ({ clientNoShow }) => {
  const { isGlobalUser } = useRole();

  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <Grid
        size={{
          sm: isGlobalUser ? 2 : 3,
        }}
      >
        <DatePicker
          control={control}
          errors={errors}
          name="date"
          openTo="date"
          label="Date of Visit"
          maxDate={new Date().toISOString()}
        />
      </Grid>
      <Grid
        size={{
          sm: 3,
        }}
      >
        <Select
          control={control}
          errors={errors}
          name="type"
          options={formatEnumToOptions(TypeOfVisit)}
          label="Type of Visit"
          hideSelectedOptions={false}
          openMenuOnFocus
        />
      </Grid>
      <Grid
        size={{
          sm: isGlobalUser ? 2 : 3,
        }}
      >
        <TimePicker
          control={control}
          errors={errors}
          name="startTime"
          label={clientNoShow ? 'Time of Visit' : 'Start time'}
        />
      </Grid>
      {!clientNoShow && (
        <Grid
          size={{
            sm: isGlobalUser ? 2 : 3,
          }}
        >
          <InputMask
            alwaysShowMask={false}
            mask="99:99"
            control={control}
            errors={errors}
            name="duration"
            label="Duration"
            endAdornment={<ClockIcon />}
            maskPlaceholder="-"
          />
        </Grid>
      )}
    </>
  );
};

export default memo(VisitDateSelectFields);
